import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaArrowLeft } from 'react-icons/fa';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #00bfa5;
  color: white;
  padding: 10px;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  margin-right: 10px;
`;

const DoctorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const DoctorName = styled.span`
  font-weight: bold;
`;

const DoctorSpecialty = styled.span`
  font-size: 12px;
  font-style: italic;
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  margin-right: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

interface ChatHistoryHeaderProps {
  onBack: () => void;
  chatName: string;
  chatAvatar?: string;
  chatRoomId?: number;
  chatSpeciality?: string;
}

const ChatHistoryHeader: React.FC<ChatHistoryHeaderProps> = ({ 
  onBack,
  chatName,
  chatAvatar,
  chatRoomId,
  chatSpeciality
 }) => {

  return (
    <HeaderContainer>
      <BackButton onClick={onBack}>
        <FaArrowLeft />
      </BackButton>
      <Avatar
        src={chatAvatar || "https://m.linksehat.com/assets/img/users/female-avatar.png"}
        alt={chatName}
      />
      <DoctorInfo>
        <DoctorName>{chatName}</DoctorName>
        {chatSpeciality && <DoctorSpecialty>{chatSpeciality}</DoctorSpecialty>}
      </DoctorInfo>
    </HeaderContainer>
  );
};

export default ChatHistoryHeader;
